import {getElement, store} from '@wordpress/interactivity';

const {state} = store('wpbs/flyout', {
    state: {
        active: false,
    },
    actions: {
        toggle: (event) => {
            const {ref} = getElement();

            const el = event.currentTarget;

            const isButton = el.closest('.wpbs-flyout-toggle:not(.wpbs-flyout)') !== null;

            if (isButton) {
                state.active = !state.active;

                requestAnimationFrame(() => {
                    document.body.classList.toggle('wpbs-body-lock', state.active);
                    MediaWatcher.observeMedia(document.querySelector('.wpbs-flyout'));
                });
            }

        },
        clear: (event) => {
            const {ref} = getElement();

            if (
                event.target.closest('.wpbs-flyout__scroll') &&
                !event.target.classList.contains('wpbs-flyout__scroll')
            ) {
                return;
            }

            state.active = !state.active;

            requestAnimationFrame(() => {
                document.body.classList.toggle('wpbs-body-lock', state.active);
            });
        },
    },
});
